export const CW_APP_SOURCE = 'CW';
export const GDPR_SETTINGS = 'cw-gdpr-settings';
export const LEGAL_BASE_URL = import.meta.env.VITE_LANDING_URL;
export const COOKIE_PATH = `${LEGAL_BASE_URL}/cookie-policy`;
export const EMPLOYERS_PATH = `${LEGAL_BASE_URL}/employers`;
export const PRODUCTION_URL = 'employer.joblio.co';

export const CLIENT_FORM_ID = 'employer-form';
